export default __webpack_public_path__ + "static/1.7.6/media/europeanFoundations.620a0de2.svg";